/** A bejelentkezett felhasználó munkamenete (indításkor az api().me() tölti fel). */
import { create } from 'zustand'
import type { Session } from '@/api/types'

interface SessionState {
  session: Session | null
  setSession: (session: Session | null) => void
}

export const useSession = create<SessionState>((set) => ({
  session: null,
  setSession: (session) => set({ session }),
}))

/** Érvényes munkamenet (a lejártat a felület is figyeli, nem csak a szerver). */
export function currentSession(now = new Date()): Session | null {
  const s = useSession.getState().session
  if (s && new Date(s.expiresAt) <= now) {
    useSession.setState({ session: null })
    return null
  }
  return s
}
